import { routerMain } from 'constants/routerMain';
import { routerPathMain } from 'constants/routerPathMain';
import { lazy } from 'react';

const ReferenceTemplateText = lazy(() => import('features/reference-template/reference-template-text/pages/ReferenceTemplateText'));

const ReferenceTemplateContract = lazy(() => import('features/reference-template/reference-template-contract/pages/ReferenceTemplateContract'));
const ReferenceTemplateContractNew = lazy(() => import('features/reference-template/reference-template-contract-new/pages/ReferenceTemplateContractNew'));
const ReferenceTemplateContractNewAdd = lazy(() => import('features/reference-template/reference-template-contract-new/components/ReferenceTemplateContractNewAdd'));

const ReferenceTemplateRouter = [
    // document
    {
        path: routerMain.REFERENCE_TEMPLATE_TEXT,
        exact: true,
        component: ReferenceTemplateText,
    },
    {
        path: routerMain.REFERENCE_TEMPLATE_TEXT_LEGACY,
        exact: true,
        component: ReferenceTemplateText,
    },
    {
        path: routerMain.REFERENCE_TEMPLATE_CONTRACT,
        exact: true,
        component: ReferenceTemplateContract,
    },
    {
        path: routerMain.REFERENCE_TEMPLATE_CONTRACT_LEGACY,
        exact: true,
        component: ReferenceTemplateContract,
    },
    {
        path: routerMain.REFERENCE_TEMPLATE_CONTRACT_NEW,
        exact: true,
        component: ReferenceTemplateContractNew,
    },
    {
        path: routerMain.REFERENCE_TEMPLATE_CONTRACT_NEW + routerPathMain.ADD,
        exact: false,
        component: ReferenceTemplateContractNewAdd,
    },
    {
        path: routerMain.REFERENCE_TEMPLATE_CONTRACT_NEW + routerPathMain.EDIT,
        exact: false,
        component: ReferenceTemplateContractNewAdd,
    },
];
export default ReferenceTemplateRouter;
